<div class="relative" #menuContainer>

  <!-- Trigger button -->
  <button type="button" (click)="toggleMenu($event)"
    class="relative flex items-center justify-center w-9 h-9 rounded-full hover:ring-2 hover:ring-primary-500 hover:ring-offset-2 focus:outline-none transition-all overflow-hidden">
    <img *ngIf="showAvatar && user?.profile_image"
         class="w-full h-full object-cover rounded-full"
         [src]="user?.profile_image | profileImageUrl" />
    <mat-icon *ngIf="!showAvatar || !user?.profile_image"
              class="text-secondary"
              [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
  </button>

  <!-- ── Mega-menu panel ── -->
  <div *ngIf="isMenuOpen"
       class="absolute right-0 top-full mt-2 z-[999] w-[440px] rounded-2xl shadow-2xl
              bg-white dark:bg-gray-900
              border border-gray-200 dark:border-gray-700
              overflow-hidden">

    <!-- ── User identity header ── -->
    <div class="flex items-center gap-3 px-5 py-4 border-b border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/50">
      <div class="flex-shrink-0">
        <img *ngIf="showAvatar && user?.profile_image"
             class="w-10 h-10 rounded-full object-cover ring-2 ring-white dark:ring-gray-700 shadow-sm"
             [src]="user?.profile_image | profileImageUrl" />
        <div *ngIf="!showAvatar || !user?.profile_image"
             class="w-10 h-10 rounded-full bg-primary-100 dark:bg-primary-900/40 flex items-center justify-center">
          <mat-icon class="text-primary-600 dark:text-primary-400 icon-size-5"
                    [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        </div>
      </div>
      <div class="min-w-0 flex-1">
        <p class="text-sm font-semibold text-gray-900 dark:text-white truncate">{{ user?.name }}</p>
        <div class="flex flex-wrap gap-1 mt-1">
          <span *ngFor="let badge of roleBadges"
                class="inline-flex items-center text-xs font-medium px-2 py-0.5 rounded-full"
                [ngClass]="badge.cls">
            {{ badge.label }}
          </span>
        </div>
      </div>
    </div>

    <!-- ── Nav items: two independent columns ── -->
    <div class="p-3 flex gap-0">

      <!-- Left column: Awards / Schedule / Path ── divider ── Settings -->
      <div class="flex-1 flex flex-col">

        <!-- Awards & Certificates -->
        <button type="button"
                (click)="navigateToTab('/user-settings/user', 'certificates')"
                class="flex items-start gap-3 p-3 rounded-xl text-left transition-colors hover:bg-gray-50 dark:hover:bg-gray-800 group">
          <div class="flex-shrink-0 w-9 h-9 rounded-lg bg-gray-100 dark:bg-gray-800 flex items-center justify-center group-hover:bg-gray-200 dark:group-hover:bg-gray-700 transition-colors">
            <mat-icon class="icon-size-4 text-gray-500 dark:text-gray-400"
                      [svgIcon]="'heroicons_outline:trophy'"></mat-icon>
          </div>
          <div>
            <p class="text-sm font-semibold text-gray-900 dark:text-white">{{ 'user.awards' | translate }}</p>
            <p class="mt-0.5 text-xs text-gray-500 dark:text-gray-400 leading-snug">
              {{ 'user.awardsDesc' | translate }}
            </p>
          </div>
        </button>

        <!-- Study Schedule (student only) -->
        <button *ngIf="_role === UserRole.Student"
                type="button"
                (click)="navigateToTab('/user-settings/user', 'schedule')"
                class="flex items-start gap-3 p-3 rounded-xl text-left transition-colors hover:bg-gray-50 dark:hover:bg-gray-800 group">
          <div class="flex-shrink-0 w-9 h-9 rounded-lg bg-gray-100 dark:bg-gray-800 flex items-center justify-center group-hover:bg-gray-200 dark:group-hover:bg-gray-700 transition-colors">
            <mat-icon class="icon-size-4 text-gray-500 dark:text-gray-400"
                      [svgIcon]="'heroicons_outline:calendar-days'"></mat-icon>
          </div>
          <div>
            <p class="text-sm font-semibold text-gray-900 dark:text-white">{{ 'user.schedule' | translate }}</p>
            <p class="mt-0.5 text-xs text-gray-500 dark:text-gray-400 leading-snug">
              {{ 'user.scheduleDesc' | translate }}
            </p>
          </div>
        </button>

        <!-- Study Path (student only) -->
        <button *ngIf="_role === UserRole.Student"
                type="button"
                (click)="navigateToTab('/user-settings/user', 'study-path')"
                class="flex items-start gap-3 p-3 rounded-xl text-left transition-colors hover:bg-gray-50 dark:hover:bg-gray-800 group">
          <div class="flex-shrink-0 w-9 h-9 rounded-lg bg-gray-100 dark:bg-gray-800 flex items-center justify-center group-hover:bg-gray-200 dark:group-hover:bg-gray-700 transition-colors">
            <mat-icon class="icon-size-4 text-gray-500 dark:text-gray-400"
                      [svgIcon]="'heroicons_outline:map'"></mat-icon>
          </div>
          <div>
            <p class="text-sm font-semibold text-gray-900 dark:text-white">{{ 'user.studyPath' | translate }}</p>
            <p class="mt-0.5 text-xs text-gray-500 dark:text-gray-400 leading-snug">
              {{ 'user.studyPathDesc' | translate }}
            </p>
          </div>
        </button>

        <!-- Divider (only shown when student items are present) -->
        <div *ngIf="_role === UserRole.Student"
             class="my-1 mx-2 border-t border-gray-100 dark:border-gray-800"></div>

        <!-- Settings -->
        <button type="button"
                (click)="navigateTo('/user-settings')"
                class="flex items-start gap-3 p-3 rounded-xl text-left transition-colors hover:bg-gray-50 dark:hover:bg-gray-800 group">
          <div class="flex-shrink-0 w-9 h-9 rounded-lg bg-gray-100 dark:bg-gray-800 flex items-center justify-center group-hover:bg-gray-200 dark:group-hover:bg-gray-700 transition-colors">
            <mat-icon class="icon-size-4 text-gray-500 dark:text-gray-400"
                      [svgIcon]="'heroicons_outline:cog-6-tooth'"></mat-icon>
          </div>
          <div>
            <p class="text-sm font-semibold text-gray-900 dark:text-white">{{ 'user.settings' | translate }}</p>
            <p class="mt-0.5 text-xs text-gray-500 dark:text-gray-400 leading-snug">
              {{ 'user.settingsDesc' | translate }}
            </p>
          </div>
        </button>

        <!-- Company Settings (CourseAdmin / permitted Supervisor) -->
        <button *ngIf="showCompanySettings"
                type="button"
                (click)="navigateTo('/system-settings')"
                class="flex items-start gap-3 p-3 rounded-xl text-left transition-colors hover:bg-gray-50 dark:hover:bg-gray-800 group">
          <div class="flex-shrink-0 w-9 h-9 rounded-lg bg-gray-100 dark:bg-gray-800 flex items-center justify-center group-hover:bg-gray-200 dark:group-hover:bg-gray-700 transition-colors">
            <mat-icon class="icon-size-4 text-gray-500 dark:text-gray-400"
                      [svgIcon]="'heroicons_outline:building-office-2'"></mat-icon>
          </div>
          <div>
            <p class="text-sm font-semibold text-gray-900 dark:text-white">{{ 'user.companySettings' | translate }}</p>
            <p class="mt-0.5 text-xs text-gray-500 dark:text-gray-400 leading-snug">
              {{ 'user.companySettingsDesc' | translate }}
            </p>
          </div>
        </button>

      </div><!-- /left column -->

      <!-- Right column: Help / Orientation / Support — grouped in a soft card -->
      <div class="flex-1 flex flex-col ml-2">
        <div class="flex flex-col h-full rounded-xl bg-gray-50 dark:bg-gray-800/60 p-1">

          <!-- Help -->
          <button type="button"
                  (click)="openHelp()"
                  class="flex items-start gap-3 p-3 rounded-lg text-left transition-colors hover:bg-white dark:hover:bg-gray-700 group">
            <div class="flex-shrink-0 w-9 h-9 rounded-lg bg-white dark:bg-gray-700 shadow-sm flex items-center justify-center group-hover:bg-gray-100 dark:group-hover:bg-gray-600 transition-colors">
              <mat-icon class="icon-size-4 text-gray-500 dark:text-gray-400"
                        [svgIcon]="'heroicons_outline:question-mark-circle'"></mat-icon>
            </div>
            <div>
            <p class="text-sm font-semibold text-gray-900 dark:text-white">{{ 'user.help' | translate }}</p>
            <p class="mt-0.5 text-xs text-gray-500 dark:text-gray-400 leading-snug">
              {{ 'user.helpDesc' | translate }}
            </p>
            </div>
          </button>

          <!-- Orientation Tour -->
          <button type="button"
                  (click)="startOrientation()"
                  class="flex items-start gap-3 p-3 rounded-lg text-left transition-colors hover:bg-white dark:hover:bg-gray-700 group">
            <div class="flex-shrink-0 w-9 h-9 rounded-lg bg-white dark:bg-gray-700 shadow-sm flex items-center justify-center group-hover:bg-gray-100 dark:group-hover:bg-gray-600 transition-colors">
              <mat-icon class="icon-size-4 text-gray-500 dark:text-gray-400"
                        [svgIcon]="'heroicons_outline:academic-cap'"></mat-icon>
            </div>
            <div>
            <p class="text-sm font-semibold text-gray-900 dark:text-white">{{ 'user.orientation' | translate }}</p>
            <p class="mt-0.5 text-xs text-gray-500 dark:text-gray-400 leading-snug">
              {{ 'user.orientationDesc' | translate }}
            </p>
            </div>
          </button>

          <!-- Support -->
          <button type="button"
                  (click)="navigateTo('/support')"
                  class="flex items-start gap-3 p-3 rounded-lg text-left transition-colors hover:bg-white dark:hover:bg-gray-700 group">
            <div class="flex-shrink-0 w-9 h-9 rounded-lg bg-white dark:bg-gray-700 shadow-sm flex items-center justify-center group-hover:bg-gray-100 dark:group-hover:bg-gray-600 transition-colors">
              <mat-icon class="icon-size-4 text-gray-500 dark:text-gray-400"
                        [svgIcon]="'heroicons_outline:chat-bubble-left-right'"></mat-icon>
            </div>
            <div>
            <p class="text-sm font-semibold text-gray-900 dark:text-white">{{ 'user.support' | translate }}</p>
            <p class="mt-0.5 text-xs text-gray-500 dark:text-gray-400 leading-snug">
              {{ 'user.supportDesc' | translate }}
            </p>
            </div>
          </button>

        </div>
      </div><!-- /right column -->

    </div><!-- /two-column nav -->

    <!-- ── Sign-out footer ── -->
    <div class="px-3 pb-3 pt-1 border-t border-gray-100 dark:border-gray-800">
      <button type="button"
              (click)="signOut()"
              class="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl transition-colors
                     hover:bg-red-50 dark:hover:bg-red-900/20 text-left group">
        <div class="flex-shrink-0 w-9 h-9 rounded-lg bg-gray-100 dark:bg-gray-800 flex items-center justify-center group-hover:bg-gray-200 dark:group-hover:bg-gray-700 transition-colors">
          <mat-icon class="icon-size-4 text-gray-500 dark:text-gray-400"
                    [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
        </div>
        <span class="text-sm font-semibold text-red-600 dark:text-red-400">{{ 'nav.signOut' | translate }}</span>
      </button>
    </div>

  </div><!-- /panel -->

</div><!-- /relative wrapper -->
